import React, { useEffect } from 'react'
// import Input from 'components/Input'
// import { filterValues } from 'Helper'
import { withTranslation } from 'react-i18next'
// import { FormControlLabel, Radio, RadioGroup } from '@mui/material'
// import useSWR from 'swr'
import { FormProvider, useForm } from 'react-hook-form'
// import Checkbox from 'components/Checkbox'
import Btn from 'components/Btn'
import { useDispatch } from 'react-redux'
import ReviewForm from './ReviewForm'
import { previewModal } from 'store/slices/miscSlice'
import useBankInfo from 'hooks/useBankInfo'
import RadioBtn from 'components/RadioBtn'
import BankTransfer from './BankTransfer'
import Momo from './BankTransfer'


export default withTranslation()(function Transfer({ t }) {
  const {bank} = useBankInfo()
  const dispatch = useDispatch()

  // const [branches, setBranches] = useState(null)
  // const [value, setValue] = useState(null)

  // useEffect(() => {
  //   if (Branches?.data) setBranches(Branches.data.data)
  // }, [Branches])
  const method = useForm({
    mode: 'all'
  })

  const { reset, watch } = method

  useEffect(() => {
    reset({
      method: 'bank_transfer',
    })
  }, [reset])

  if (JSON.stringify(bank) === '{}') return <div className="bg-red">Please update your bank details to continue</div>

  return (
    <div className="w-full bg-white rounded-lg overflow-hidden">
      <FormProvider {...method}>
        <form className="max-w-md mx-auto">
          <label className="font-bold text-2xl block mb-8 text-center">{ t('redemption.form.title') }</label>
          
            <RadioBtn 
              name="method"
              options={
                [
                  {
                    value: 'bank_transfer',
                    label: t('redemption.form.0.0')
                  },
                  {
                    value: 'momo',
                    label: t('redemption.form.0.1')
                  }
                ]
              }
              value="bank_transfer"
            />

            {
              watch('method') === 'bank_transfer' ? (
                <BankTransfer 
                  bank={bank} 
                />
              ) : (
                <Momo />
              )
            }
                       
          
            {/* <FormBtn 
              text={t('redemption.form.submit')}
              textColor="text-white"
              classList="w-full h-12"
              disabled={ !isValid || !isDirty }
              bg="#1976D2"
            /> */}
            <Btn 
              content={t('redemption.form.submit')}
              className="w-full h-12 text-white rounded-xl bg-primary"
              click={() => dispatch(previewModal({
                title: () => <div className="grid grid-cols-5 items-end text-left p-4">
                  <label className="font-semibold text-2xl col-span-3">Review</label>
                  <span className="text-sm col-span-2">Sept 16, 2022 17:12:18</span>
                </div>,
                  content: () => <ReviewForm />
                }))
              }
            />
        </form>
      </FormProvider>
    </div>
  )
})